import { Col, Button } from 'antd';
import React, { ReactNode } from 'react';

interface ModalFooterProps {
  onCancel?: () => void;
  buttonText?: string | ReactNode;
  submit?: boolean;
  buttonIcon?: React.ReactNode;
}

function ModalFooter({
  onCancel,
  buttonText,
  submit,
  buttonIcon,
}: ModalFooterProps) {
  const handleCancel = () => {
    onCancel?.();
  };
  return (
    <div className="flex justify-center md:flex md:justify-end">
      {submit ? (
        <Button
          className="bg-[#D10D74] h-[41px] flex items-center py-2 cursor-pointer hover:scale-[1.03] transition-all hover:shadow-md hover:shadow-pink-600"
          style={{ borderRadius: 0 }}
        >
          <div className="flex gap-4 justify-center items-center p-5 lg:px-5 md:px-10">
            <Col className="text-[18px] text-white">{buttonIcon}</Col>
            <Col className="text-2xl font-extrabold text-white">
              {buttonText}
            </Col>
          </div>
        </Button>
      ) : (
        <Button
          className={
            buttonText === 'Back to home'
              ? 'h-[41px] flex items-center py-2 cursor-pointer hover:scale-[1.03] transition-all hover:shadow-sm hover:shadow-pink-600 border-pink-600'
              : 'bg-[#D10D74] h-[41px] flex items-center py-2 cursor-pointer hover:scale-[1.03] transition-all hover:shadow-sm hover:shadow-pink-600'
          }
          onClick={handleCancel}
          style={{ borderRadius: 0 }}
        >
          <div className="flex gap-4 justify-center items-center p-5 lg:px-5 md:px-10">
            <Col
              className={
                buttonText === 'Back to home'
                  ? 'text-[18px] text-pink-600 mb-2'
                  : 'text-[18px] white mb-2 text-white'
              }
            >
              {buttonIcon}
            </Col>
            <Col
              className={
                buttonText === 'Back to home'
                  ? 'text-2xl font-extrabold text-pink-600'
                  : 'text-2xl font-extrabold text-white'
              }
            >
              {buttonText}
            </Col>
          </div>
        </Button>
      )}
    </div>
  );
}

export default React.memo(ModalFooter);
